var _style, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _g, _g2, _defs;
var _excluded = ["alt"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgSeemoreThinking = function SvgSeemoreThinking(_ref) {
  var alt = _ref.alt,
    props = _objectWithoutProperties(_ref, _excluded);
  var accessibilityProps = alt ? {
    'aria-label': alt,
    role: 'img'
  } : {};
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      overflow: "visible"
    },
    viewBox: "0 0 163 46"
  }, accessibilityProps, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes kf_dots_transform_0{.11%,0%,3.68%{transform:translateX(47px) translateY(32px) translateX(0) translateY(0)}10.83%,to{transform:translateX(47px) translateY(32px) translateX(-47px) translateY(0)}}@keyframes kf_dots_2_transform_0{0%,10.83%,18.05%{transform:translateX(64px) translateY(32px) translateX(0) translateY(0)}25.24%,to{transform:translateX(64px) translateY(32px) translateX(-47px) translateY(0)}}@keyframes kf_dots_3_transform_0{0%,25.1%,32.23%{transform:translateX(81px) translateY(32px) translateX(0) translateY(0)}39.37%,to{transform:translateX(81px) translateY(32px) translateX(-47px) translateY(0)}}@keyframes kf_dots_4_transform_0{0%,39.37%,46.5%{transform:translateX(98px) translateY(32px) translateX(0) translateY(0)}53.64%,to{transform:translateX(98px) translateY(32px) translateX(-47px) translateY(0)}}@keyframes kf_dots_5_transform_0{0%,53.64%,60.77%{transform:translateX(115px) translateY(32px) translateX(0) translateY(0)}67.91%,to{transform:translateX(115px) translateY(32px) translateX(-46px) translateY(0)}}@keyframes kf_dots_6_transform_0{0%,67.91%,75.04%{transform:translateX(132px) translateY(32px) translateX(0) translateY(0)}82.18%,to{transform:translateX(132px) translateY(32px) translateX(-46px) translateY(0)}}@keyframes kf_dots_7_transform_0{0%,82.21%,89.35%{transform:translateX(149px) translateY(32px) translateX(0) translateY(0)}96.48%,to{transform:translateX(149px) translateY(32px) translateX(-46px) translateY(0)}}@keyframes kf_seemore_thoughtbubble_transform_0{0%,3.68%{transform:translateX(0) translateY(0)}10.72%,17.88%{transform:translateX(17px) translateY(0)}25.01%,32.15%{transform:translateX(34px) translateY(0)}39.23%,46.4%{transform:translateX(51px) translateY(0)}53.64%,60.62%{transform:translateX(69px) translateY(0)}67.81%,75.04%{transform:translateX(86px) translateY(0)}82.12%,89.24%{transform:translateX(103px) translateY(0)}96.3%,to{transform:translateX(120px) translateY(0)}}")), /*#__PURE__*/React.createElement("g", {
    id: "seemore_thinking_svg__Seemore_Thinking_Animated"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    width: 70,
    height: 70,
    x: 17,
    y: 2
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(15px)",
      clipPath: "url(#seemore_thinking_svg__bgblur_0_7106_11278_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 30,
    filter: "url(#seemore_thinking_svg__filter0_d_7106_11278)",
    style: {
      transformOrigin: "0 0",
      animation: "kf_dots_transform_0 5.606374s linear infinite alternate"
    },
    transform: "translate(47 32)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "seemore_thinking_svg__dots_bg_0",
    cx: 5,
    cy: 5,
    r: 5,
    fill: "currentColor",
    fillOpacity: 0.35,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 70,
    height: 70,
    x: 34,
    y: 2
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(15px)",
      clipPath: "url(#seemore_thinking_svg__bgblur_1_7106_11278_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 30,
    filter: "url(#seemore_thinking_svg__filter1_d_7106_11278)",
    style: {
      transformOrigin: "0 0",
      animation: "kf_dots_2_transform_0 5.606374s linear infinite alternate"
    },
    transform: "translate(64 32)"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "seemore_thinking_svg__dots_2_bg_0",
    cx: 5,
    cy: 5,
    r: 5,
    fill: "currentColor",
    fillOpacity: 0.35,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 70,
    height: 70,
    x: 51,
    y: 2
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(15px)",
      clipPath: "url(#seemore_thinking_svg__bgblur_2_7106_11278_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 30,
    filter: "url(#seemore_thinking_svg__filter2_d_7106_11278)",
    style: {
      transformOrigin: "0 0",
      animation: "kf_dots_3_transform_0 5.606374s linear infinite alternate"
    },
    transform: "translate(81 32)"
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "seemore_thinking_svg__dots_3_bg_0",
    cx: 5,
    cy: 5,
    r: 5,
    fill: "currentColor",
    fillOpacity: 0.35,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 70,
    height: 70,
    x: 68,
    y: 2
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(15px)",
      clipPath: "url(#seemore_thinking_svg__bgblur_3_7106_11278_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 30,
    filter: "url(#seemore_thinking_svg__filter3_d_7106_11278)",
    style: {
      transformOrigin: "0 0",
      animation: "kf_dots_4_transform_0 5.606374s linear infinite alternate"
    },
    transform: "translate(98 32)"
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "seemore_thinking_svg__dots_4_bg_0",
    cx: 5,
    cy: 5,
    r: 5,
    fill: "currentColor",
    fillOpacity: 0.35,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 70,
    height: 70,
    x: 85,
    y: 2
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(15px)",
      clipPath: "url(#seemore_thinking_svg__bgblur_4_7106_11278_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 30,
    filter: "url(#seemore_thinking_svg__filter4_d_7106_11278)",
    style: {
      transformOrigin: "0 0",
      animation: "kf_dots_5_transform_0 5.606374s linear infinite alternate"
    },
    transform: "translate(115 32)"
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "seemore_thinking_svg__dots_5_bg_0",
    cx: 5,
    cy: 5,
    r: 5,
    fill: "currentColor",
    fillOpacity: 0.35,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 70,
    height: 70,
    x: 102,
    y: 2
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(15px)",
      clipPath: "url(#seemore_thinking_svg__bgblur_5_7106_11278_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 30,
    filter: "url(#seemore_thinking_svg__filter5_d_7106_11278)",
    style: {
      transformOrigin: "0 0",
      animation: "kf_dots_6_transform_0 5.606374s linear infinite alternate"
    },
    transform: "translate(132 32)"
  }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "seemore_thinking_svg__dots_6_bg_0",
    cx: 5,
    cy: 5,
    r: 5,
    fill: "currentColor",
    fillOpacity: 0.35,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 70,
    height: 70,
    x: 119,
    y: 2
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(15px)",
      clipPath: "url(#seemore_thinking_svg__bgblur_6_7106_11278_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 30,
    filter: "url(#seemore_thinking_svg__filter6_d_7106_11278)",
    style: {
      transformOrigin: "0 0",
      animation: "kf_dots_7_transform_0 5.606374s linear infinite alternate"
    },
    transform: "translate(149 32)"
  }, _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "seemore_thinking_svg__dots_7_bg_0",
    cx: 5,
    cy: 5,
    r: 5,
    fill: "currentColor",
    fillOpacity: 0.35,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#seemore_thinking_svg__clip7_7106_11278)",
    style: {
      transformOrigin: "0 0",
      animation: "kf_seemore_thoughtbubble_transform_0 5.606374s linear infinite alternate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "seemore_thinking_svg__seemore",
    transform: "translate(0 19.033)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "seemore_thinking_svg__Vector",
    fill: "currentColor",
    d: "M15.364 1.372a10.87 10.87 0 0 0-10.572 0C1.827 3.029 0 6.096 0 9.41c3.271 1.829 5.286 5.209 5.286 8.867l1.821 1.018a6.11 6.11 0 0 0 5.941 0l1.822-1.018c0-3.658 2.015-7.038 5.286-8.867 0-3.315-1.827-6.382-4.792-8.04",
    transform: "translate(10.07 8.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "seemore_thinking_svg__Vector_2",
    fill: "currentColor",
    d: "M.72 1.433A.717.717 0 1 1 .72 0a.717.717 0 1 1 0 1.433",
    transform: "translate(15.836 7.167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "seemore_thinking_svg__Vector_3",
    fill: "currentColor",
    d: "M7.199 4.104C4.075 4.91.849 3.158 0 .196c3.124-.806 6.349.946 7.199 3.908",
    transform: "translate(5.758 18.634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "seemore_thinking_svg__Vector_4",
    fill: "currentColor",
    d: "M8.638 1.181C6.728 4.403 2.857 5.27 0 3.12 1.91-.103 5.781-.97 8.638 1.18",
    transform: "translate(4.316 22.933)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "seemore_thinking_svg__Vector_5",
    fill: "currentColor",
    d: "M3.986 0C5.067 2.346 3.428 4.915.333 5.733-.748 3.387.891.818 3.986 0",
    transform: "translate(10.07 25.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "seemore_thinking_svg__Vector_6",
    fill: "currentColor",
    d: "M.387 0c3.132 1.08 4.719 4.292 3.545 7.167C.8 6.087-.787 2.875.387 0",
    transform: "translate(25.914 25.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "seemore_thinking_svg__Vector_7",
    fill: "currentColor",
    d: "M0 .254C2.894-.52 6.12.537 7.199 2.612 4.305 3.388 1.079 2.33 0 .254",
    transform: "translate(27.352 24.367)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "seemore_thinking_svg__Vector_8",
    fill: "currentColor",
    d: "M0 4.064C.91 1.058 4.137-.656 7.199.236 6.289 3.242 3.062 4.956 0 4.064",
    transform: "translate(27.352 18.634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "seemore_thinking_svg__Vector_9",
    fill: "currentColor",
    d: "M7.048 9.946c-.202-1.89.492-3.667 1.754-4.962.394-.402.048-1.05-.529-.998l-2.445.232L8.183 0C2.973.508-.761 5.07.133 10.039c.746 4.147 4.643 7.218 9.09 7.16h.113l.742-2.546c-1.65-1.018-2.82-2.707-3.033-4.705z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "seemore_thinking_svg__Vector_10",
    fill: "currentColor",
    d: "M3.07 9.98c.227-1.886-.435-3.682-1.667-5.005-.384-.412-.032-1.054.539-.986l2.42.287L2.089 0c5.156.624 8.792 5.277 7.836 10.23-.799 4.134-4.706 7.123-9.113 6.964q-.057 0-.114-.005L0 14.624c1.651-.981 2.835-2.646 3.072-4.644z",
    transform: "translate(30.234)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "seemore_thinking_svg__Vector_11",
    fill: "currentColor",
    d: "M.72 1.433A.717.717 0 1 1 .72 0a.717.717 0 1 1 0 1.433",
    transform: "translate(23.027 7.167)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 81.539,
    height: 81.539,
    x: -15,
    y: -30
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(15px)",
      clipPath: "url(#seemore_thinking_svg__bgblur_8_7106_11278_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "seemore_thinking_svg__thought-bubble",
    "data-figma-bg-blur-radius": 30,
    filter: "url(#seemore_thinking_svg__filter7_d_7106_11278)",
    transform: "translate(15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "seemore_thinking_svg__thought-bubble_bg_0",
    fill: "currentColor",
    fillOpacity: 0.35,
    d: "M15.775 3.263h.379c2.987 0 5.384 2.326 5.384 5.222s-2.397 5.221-5.384 5.221c-.463 0-.968-.04-1.388-.163a4.8 4.8 0 0 1-3.997 2.121 4.8 4.8 0 0 1-3.996-2.12c-.42.121-.884.162-1.388.162C2.398 13.706 0 11.381 0 8.485s2.398-5.222 5.385-5.222h.378C6.563 1.346 8.498 0 10.77 0s4.207 1.346 5.006 3.263m-9.044 16.97c-1.136 0-2.02-.857-2.02-1.958s.884-1.958 2.02-1.958 2.019.857 2.019 1.958c0 1.102-.883 1.958-2.02 1.958m-4.712 1.305c-.757 0-1.346-.57-1.346-1.305 0-.734.589-1.305 1.346-1.305s1.346.57 1.346 1.305c0 .734-.589 1.305-1.346 1.305",
    shapeRendering: "crispEdges"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "seemore_thinking_svg__bgblur_0_7106_11278_clip_path",
    transform: "translate(-17 -2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "seemore_thinking_svg__bgblur_1_7106_11278_clip_path",
    transform: "translate(-34 -2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "seemore_thinking_svg__bgblur_2_7106_11278_clip_path",
    transform: "translate(-51 -2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "seemore_thinking_svg__bgblur_3_7106_11278_clip_path",
    transform: "translate(-68 -2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "seemore_thinking_svg__bgblur_4_7106_11278_clip_path",
    transform: "translate(-85 -2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "seemore_thinking_svg__bgblur_5_7106_11278_clip_path",
    transform: "translate(-102 -2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "seemore_thinking_svg__bgblur_6_7106_11278_clip_path",
    transform: "translate(-119 -2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "seemore_thinking_svg__bgblur_8_7106_11278_clip_path",
    transform: "translate(15 30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.775 3.263h.379c2.987 0 5.384 2.326 5.384 5.222s-2.397 5.221-5.384 5.221c-.463 0-.968-.04-1.388-.163a4.8 4.8 0 0 1-3.997 2.121 4.8 4.8 0 0 1-3.996-2.12c-.42.121-.884.162-1.388.162C2.398 13.706 0 11.381 0 8.485s2.398-5.222 5.385-5.222h.378C6.563 1.346 8.498 0 10.77 0s4.207 1.346 5.006 3.263m-9.044 16.97c-1.136 0-2.02-.857-2.02-1.958s.884-1.958 2.02-1.958 2.019.857 2.019 1.958c0 1.102-.883 1.958-2.02 1.958m-4.712 1.305c-.757 0-1.346-.57-1.346-1.305 0-.734.589-1.305 1.346-1.305s1.346.57 1.346 1.305c0 .734-.589 1.305-1.346 1.305"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "seemore_thinking_svg__clip7_7106_11278"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h40v42H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "seemore_thinking_svg__filter0_d_7106_11278",
    width: 70,
    height: 70,
    x: -30,
    y: -30,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7106_11278"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_7106_11278",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "seemore_thinking_svg__filter1_d_7106_11278",
    width: 70,
    height: 70,
    x: -30,
    y: -30,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7106_11278"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_7106_11278",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "seemore_thinking_svg__filter2_d_7106_11278",
    width: 70,
    height: 70,
    x: -30,
    y: -30,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7106_11278"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_7106_11278",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "seemore_thinking_svg__filter3_d_7106_11278",
    width: 70,
    height: 70,
    x: -30,
    y: -30,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7106_11278"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_7106_11278",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "seemore_thinking_svg__filter4_d_7106_11278",
    width: 70,
    height: 70,
    x: -30,
    y: -30,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7106_11278"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_7106_11278",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "seemore_thinking_svg__filter5_d_7106_11278",
    width: 70,
    height: 70,
    x: -30,
    y: -30,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7106_11278"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_7106_11278",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "seemore_thinking_svg__filter6_d_7106_11278",
    width: 70,
    height: 70,
    x: -30,
    y: -30,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7106_11278"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_7106_11278",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "seemore_thinking_svg__filter7_d_7106_11278",
    width: 81.539,
    height: 81.539,
    x: -30,
    y: -30,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7106_11278"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_7106_11278",
    result: "shape"
  })))));
};
export { SvgSeemoreThinking as ReactComponent };
export default __webpack_public_path__ + "static/seemore_thinking.2e93ec96.svg";